import { AccessoryCheckDto, AccessoryCheckReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type AccessoryCheckDtoAny = AccessoryCheckDto | AccessoryCheckReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type AccessoryCheckDtoAll = AccessoryCheckDto & AccessoryCheckReferenceDto;

export class AccessoryCheckMapper {}
